import type { IBattleshipGameState } from '@skillarea/game-battleship';
import { BOARD_SIZE } from '@skillarea/game-battleship';

export type TBattleshipShotSound = 'sunk' | 'hit' | 'miss';

/**
 * Derives the last shot sound from a state diff (online / WS).
 * Returns null on the first frame, when nothing changed, or on a bulk state sync.
 */
export function getBattleshipShotSoundFromStateDiff(
  prev: IBattleshipGameState,
  next: IBattleshipGameState,
): TBattleshipShotSound | null {
  const prevSunk0 = prev.sunkShips0?.length ?? 0;
  const prevSunk1 = prev.sunkShips1?.length ?? 0;
  const nextSunk0 = next.sunkShips0?.length ?? 0;
  const nextSunk1 = next.sunkShips1?.length ?? 0;
  if (nextSunk0 > prevSunk0 || nextSunk1 > prevSunk1) {
    return 'sunk';
  }

  let newCells = 0;
  let newHits = 0;

  for (let r = 0; r < BOARD_SIZE; r += 1) {
    for (let c = 0; c < BOARD_SIZE; c += 1) {
      const p0 = prev.shotsAt0[r][c];
      const n0 = next.shotsAt0[r][c];
      if (p0 === null && n0 !== null) {
        newCells += 1;
        if (n0 === 'hit') newHits += 1;
      }
      const p1 = prev.shotsAt1[r][c];
      const n1 = next.shotsAt1[r][c];
      if (p1 === null && n1 !== null) {
        newCells += 1;
        if (n1 === 'hit') newHits += 1;
      }
    }
  }

  if (newCells === 0) {
    return null;
  }

  if (newCells > 24) {
    return null;
  }

  if (newHits > 0) {
    return 'hit';
  }

  return 'miss';
}
